/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_Chat_HandoffInputs */

const tr_mascot_chat_handoff = /** @type {(inputs: Mascot_Chat_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canlı destek ekibine aktarıldın. Çevrimiçiysen yanıt burada görünecek, değilsen e-posta ile döneceğiz.`)
};

const en_mascot_chat_handoff = /** @type {(inputs: Mascot_Chat_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You've been connected to the live support team. If you're online, the reply will appear here; otherwise, we'll get back to you via email.`)
};

const de_mascot_chat_handoff = /** @type {(inputs: Mascot_Chat_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du wurdest an das Live-Support-Team weitergeleitet. Wenn du online bist, erscheint die Antwort hier, ansonsten antworten wir per E-Mail.`)
};

const ru_mascot_chat_handoff = /** @type {(inputs: Mascot_Chat_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы переключены на команду живой поддержки. Если вы в сети, ответ появится здесь, если нет — мы ответим по e-mail.`)
};

/**
* | output |
* | --- |
* | "You've been connected to the live support team. If you're online, the reply will appear here; otherwise, we'll get back to you via email." |
*
* @param {Mascot_Chat_HandoffInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mascot_chat_handoff = /** @type {((inputs?: Mascot_Chat_HandoffInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_Chat_HandoffInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mascot_chat_handoff(inputs)
	if (locale === "de") return de_mascot_chat_handoff(inputs)
	if (locale === "ru") return ru_mascot_chat_handoff(inputs)
	return tr_mascot_chat_handoff(inputs)
});